window.InterviewVideoAPI = new (function () {
    "use strict";

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['InterviewServers']);


})();